import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import styles from './WarrantyListSection.module.scss';

const ListSection = ({ listSectionData }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    // 根据设备类型获取对应的图片
    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  return (
    <ul className={styles.list}>
      {listSectionData?.map((item, index) => {
        // 处理Sitecore格式的图片数据
        const imageField = item?.fields?.image;
        const imageUrl = getImageUrl(imageField);

        // 处理Sitecore格式的富文本数据
        const textDescription = item?.fields?.textDescription?.value || '';

        return (
          <li className={styles.card} key={index} data-aos="fade-up">
            <div className={styles.textSection}>
              <div dangerouslySetInnerHTML={{ __html: textDescription }} />
            </div>
            <div className={styles.imageSection}>
              <img src={imageUrl} alt="List item image" className={styles.backgroundImage} />
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default ListSection;
